export const enableScroll = () => {
    const scrollY = document.body.style.top;
    document.body.classList.remove('disable-scroll');
    document.querySelector('html').style.scrollBehavior = "unset";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);

    setTimeout(() => {
        document.querySelector('html').style.scrollBehavior = "";
    }, 300);
};

export const disableScroll = () => {
    const scrollY = (document.body.style.top = `-${window.scrollY}px`);
    document.body.classList.add('disable-scroll');
    document.body.style.top = scrollY + "px";
    document.body.style.position = "fixed";
    document.body.style.left = 0;
    document.body.style.right = 0;
};

export function debounce(cb, delay = 1000) {
    let timeout

    return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
            cb(...args)
        }, delay)
    }
}